import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../service/loading.service';
import { TableDataColumn } from '@shared/ui/tables';

@Component({
  selector: 'feature-loading-table-skeleton',
  templateUrl: './table-skeleton.component.html',
  styleUrls: ['./table-skeleton.component.css'],
  standalone: false,
})
export class TableSkeletonComponent implements OnInit {
  columnsCount = 0;
  columnNames!: TableDataColumn[];
  numberOfRows = 10;

  constructor(public loadingService: LoadingService) {}

  ngOnInit(): void {}
}
